// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { 
//   MoreVertical, 
//   ArrowUp, 
//   MessageSquare, 
//   Trash2, 
// } from 'lucide-react';
// import { 
//   AreaChart, 
//   Area, 
//   XAxis, 
//   Tooltip, 
//   ResponsiveContainer 
// } from 'recharts';
// import SummaryApi from '../common/SummaryApi';

// // --- Components ---

// const StatCard = ({ title, value, percentage, isPositive }) => (
//   <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between h-[140px]">
//     <div className="flex justify-between items-start">
//       <h3 className="text-gray-500 font-medium text-sm">{title}</h3>
//       <button className="text-gray-400 hover:text-gray-600"><MoreVertical size={18} /></button>
//     </div>
//     <div>
//       <div className="flex items-end gap-3 mb-1">
//         <h2 className="text-3xl font-bold text-gray-800">{value}</h2>
//         <span className={`flex items-center text-sm font-semibold mb-1 ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
//           {isPositive ? <ArrowUp size={14} /> : null}
//           {percentage}%
//         </span>
//       </div>
//       <p className="text-xs text-gray-400">Last 7 days</p>
//     </div>
//   </div>
// );

// const ChartSection = () => {
//   // Hardcoded data to match the visual curve in your screenshot
//   const data = [
//     { name: 'Sun', value: 20000 },
//     { name: 'Mon', value: 35000 },
//     { name: 'Tue', value: 25000 },
//     { name: 'Wed', value: 45000 }, // Peak
//     { name: 'Thu', value: 30000 },
//     { name: 'Fri', value: 40000 },
//     { name: 'Sat', value: 30000 },
//   ];

//   return (
//     <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-full">
//       <div className="flex justify-between items-center mb-6">
//         <h3 className="font-bold text-gray-800 text-lg">Customer Overview</h3>
//         <div className="flex gap-2">
//           <button className="px-3 py-1 bg-blue-50 text-blue-600 text-xs font-bold rounded-md">This week</button>
//           <button className="px-3 py-1 text-gray-400 text-xs font-medium hover:bg-gray-50 rounded-md">Last week</button>
//           <button className="text-gray-400"><MoreVertical size={18} /></button>
//         </div>
//       </div>

//       {/* Metric Headers */}
//       <div className="flex gap-12 mb-6 border-b border-gray-100 pb-4">
//         <div className="border-b-2 border-blue-500 pb-4 -mb-4.5">
//           <h4 className="text-2xl font-bold text-gray-800">25k</h4>
//           <p className="text-xs text-gray-500 mt-1">Active Customers</p>
//         </div>
//         <div>
//           <h4 className="text-2xl font-bold text-gray-800">5.6k</h4>
//           <p className="text-xs text-gray-500 mt-1">Repeat Customers</p>
//         </div>
//         <div>
//           <h4 className="text-2xl font-bold text-gray-800">250k</h4>
//           <p className="text-xs text-gray-500 mt-1">Shop Visitor</p>
//         </div>
//         <div>
//           <h4 className="text-2xl font-bold text-gray-800">5.5%</h4>
//           <p className="text-xs text-gray-500 mt-1">Conversion Rate</p>
//         </div>
//       </div>

//       {/* Chart */}
//       <div className="h-[200px] w-full relative">
//         {/* Custom Tooltip mimicking the screenshot's "Thursday 25,409" popup */}
//         <div className="absolute left-[50%] top-[10%] bg-blue-600 text-white text-xs p-2 rounded-lg shadow-lg z-10 text-center transform -translate-x-1/2">
//           <p className="font-semibold">Thursday</p>
//           <p>25,409</p>
//           <div className="absolute bottom-[-4px] left-1/2 transform -translate-x-1/2 w-2 h-2 bg-blue-600 rotate-45"></div>
//         </div>

//         <ResponsiveContainer width="100%" height="100%">
//           <AreaChart data={data}>
//             <defs>
//               <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
//                 <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8}/>
//                 <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
//               </linearGradient>
//             </defs>
//             <Tooltip />
//             <Area 
//               type="monotone" 
//               dataKey="value" 
//               stroke="#3b82f6" 
//               strokeWidth={3} 
//               fillOpacity={1} 
//               fill="url(#colorValue)" 
//             />
//             <XAxis 
//               dataKey="name" 
//               axisLine={false} 
//               tickLine={false} 
//               tick={{fill: '#9ca3af', fontSize: 12}} 
//               dy={10}
//             />
//           </AreaChart>
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// };

// const UserTable = ({ users, loading }) => {
//   return (
//     <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mt-6">
//       <div className="overflow-x-auto">
//         <table className="w-full min-w-[800px]">
//           <thead>
//             <tr className="bg-blue-600 text-white text-left text-xs uppercase font-semibold">
//               <th className="px-6 py-4 rounded-tl-lg">S. NO</th>
//               <th className="px-6 py-4">Name</th>
//               <th className="px-6 py-4">Phone</th>
//               <th className="px-6 py-4">Order Count</th>
//               <th className="px-6 py-4">Total Spend</th>
//               <th className="px-6 py-4">Status</th>
//               <th className="px-6 py-4 rounded-tr-lg text-center">Action</th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-gray-100">
//             {loading ? (
//                <tr><td colSpan="7" className="text-center py-8 text-gray-500">Loading customers...</td></tr>
//             ) : users.map((user, index) => (
//               <tr key={user._id} className="hover:bg-gray-50 text-sm text-gray-700">
//                 <td className="px-6 py-4 font-medium text-gray-900">
//                   {index+1}
//                 </td>
//                 <td className="px-6 py-4">
//                   {user.firstName} {user.lastName}
//                 </td>
//                 <td className="px-6 py-4 font-mono text-xs text-gray-500">
//                   {user.phone || 'N/A'}
//                 </td>
//                 <td className="px-6 py-4">
//                   {/* Mock Data: Not in Schema */}
//                   {Math.floor(Math.random() * 50) + 1}
//                 </td>
//                 <td className="px-6 py-4">
//                   {/* Mock Data: Not in Schema */}
//                   {(Math.random() * 5000).toLocaleString('en-US', { style: 'currency', currency: 'INR' })}
//                 </td>
//                 <td className="px-6 py-4">
//                   <div className="flex items-center gap-2">
//                     <span className={`w-2 h-2 rounded-full ${user.isVerified ? 'bg-green-500' : 'bg-red-500'}`}></span>
//                     <span className={user.isVerified ? 'text-green-600' : 'text-red-500'}>
//                       {user.isVerified ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4">
//                   <div className="flex justify-center gap-4 text-gray-400">
//                     <button className="hover:text-blue-500"><MessageSquare size={18} /></button>
//                     <button className="hover:text-red-500"><Trash2 size={18} /></button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// // --- Main Page Container ---

// const AllUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [stats, setStats] = useState({
//     total: 0,
//     new: 0,
//     visitors: 250000 // Mocked as Schema doesn't have visitors
//   });

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     const token = localStorage.getItem('token')
//     try {
//       // Replace with your actual API endpoint
//       const response = await axios.get(SummaryApi.getAllUsers.url, {
//         headers: {
//            // Add your auth token logic here if needed
//            Authorization: `Bearer ${token}` 
//         }
//       });

//       if (response.data.success) {
//         const fetchedUsers = response.data.users;
//         setUsers(fetchedUsers);
        
//         // Calculate Stats
//         const total = response.data.count;
//         // Mocking "New Customers" (e.g., created in last 7 days)
//         const newCust = fetchedUsers.filter(u => {
//           const date = new Date(u.createdAt);
//           const sevenDaysAgo = new Date();
//           sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//           return date > sevenDaysAgo;
//         }).length;

//         setStats({ total, new: newCust || 12, visitors: 250000 });
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen">
      
//       {/* Top Layout Grid */}
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        
//         {/* Left Column: Stats Cards */}
//         <div className="flex flex-col gap-6 lg:col-span-1">
//           <StatCard 
//             title="Total Customers" 
//             value={stats.total.toLocaleString()} 
//             percentage="14.4" 
//             isPositive={true} 
//           />
//           <StatCard 
//             title="New Customers" 
//             value={stats.new.toLocaleString()} 
//             percentage="20" 
//             isPositive={true} 
//           />
//           <StatCard 
//             title="Visitor" 
//             value={stats.visitors > 1000 ? `${(stats.visitors/1000).toFixed(0)}k` : stats.visitors} 
//             percentage="20" 
//             isPositive={true} 
//           />
//         </div>

//         {/* Right Column: Graph */}
//         <div className="lg:col-span-2">
//           <ChartSection />
//         </div>
//       </div>

//       {/* Bottom Layout: Table */}
//       <UserTable users={users} loading={loading} />

//     </div>
//   );
// };

// export default AllUsers;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { 
//   MoreVertical, 
//   ArrowUp, 
//   MessageSquare, 
//   Trash2, 
// } from 'lucide-react';
// import SummaryApi from '../common/SummaryApi';

// // --- Components ---

// const StatCard = ({ title, value, percentage, isPositive }) => (
//   <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between h-[140px]">
//     <div className="flex justify-between items-start">
//       <h3 className="text-gray-500 font-medium text-sm">{title}</h3>
//       <button className="text-gray-400 hover:text-gray-600"><MoreVertical size={18} /></button>
//     </div>
//     <div>
//       <div className="flex items-end gap-3 mb-1">
//         <h2 className="text-3xl font-bold text-gray-800">{value}</h2>
//         <span className={`flex items-center text-sm font-semibold mb-1 ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
//           {isPositive ? <ArrowUp size={14} /> : null}
//           {percentage}%
//         </span>
//       </div>
//       <p className="text-xs text-gray-400">Last 7 days</p>
//     </div>
//   </div>
// );


// const UserTable = ({ users, loading }) => {
//   return (
//     <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mt-6">
//       <div className="overflow-x-auto">
//         <table className="w-full min-w-[800px]">
//           <thead>
//             <tr className="bg-blue-600 text-white text-left text-xs uppercase font-semibold">
//               <th className="px-6 py-4 rounded-tl-lg">S. NO</th>
//               <th className="px-6 py-4">Name</th>
//               <th className="px-6 py-4">Phone</th>
//               <th className="px-6 py-4">Order Count</th>
//               <th className="px-6 py-4">Total Spend</th>
//               <th className="px-6 py-4">Status</th>
//               <th className="px-6 py-4 rounded-tr-lg text-center">Action</th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-gray-100">
//             {loading ? (
//                <tr><td colSpan="7" className="text-center py-8 text-gray-500">Loading customers...</td></tr>
//             ) : users.map((user, index) => (
//               <tr key={user._id} className="hover:bg-gray-50 text-sm text-gray-700">
//                 <td className="px-6 py-4 font-medium text-gray-900">
//                   {index+1}
//                 </td>
//                 <td className="px-6 py-4">
//                   {user.firstName} {user.lastName}
//                 </td>
//                 <td className="px-6 py-4 font-mono text-xs text-gray-500">
//                   {user.phone || 'N/A'}
//                 </td>
//                 <td className="px-6 py-4">
//                   {/* Mock Data: Not in Schema */}
//                   {Math.floor(Math.random() * 50) + 1}
//                 </td>
//                 <td className="px-6 py-4">
//                   {/* Mock Data: Not in Schema */}
//                   {(Math.random() * 5000).toLocaleString('en-US', { style: 'currency', currency: 'INR' })}
//                 </td>
//                 <td className="px-6 py-4">
//                   <div className="flex items-center gap-2">
//                     <span className={`w-2 h-2 rounded-full ${user.isVerified ? 'bg-green-500' : 'bg-red-500'}`}></span>
//                     <span className={user.isVerified ? 'text-green-600' : 'text-red-500'}>
//                       {user.isVerified ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4">
//                   <div className="flex justify-center gap-4 text-gray-400">
//                     <button className="hover:text-blue-500"><MessageSquare size={18} /></button>
//                     <button className="hover:text-red-500"><Trash2 size={18} /></button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// // --- Main Page Container ---

// const AllUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [stats, setStats] = useState({
//     total: 0,
//     new: 0,
//     visitors: 250000 // Mocked as Schema doesn't have visitors
//   });

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     const token = localStorage.getItem('token')
//     try {
//       // Replace with your actual API endpoint
//       const response = await axios.get(SummaryApi.getAllUsers.url, {
//         headers: {
//            // Add your auth token logic here if needed
//            Authorization: `Bearer ${token}` 
//         }
//       });

//       if (response.data.success) {
//         const fetchedUsers = response.data.users;
//         setUsers(fetchedUsers);
        
//         // Calculate Stats
//         const total = response.data.count;
//         // Mocking "New Customers" (e.g., created in last 7 days)
//         const newCust = fetchedUsers.filter(u => {
//           const date = new Date(u.createdAt);
//           const sevenDaysAgo = new Date();
//           sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//           return date > sevenDaysAgo;
//         }).length;

//         setStats({ total, new: newCust || 12, visitors: 250000 });
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen">
//       <h1 className="text-2xl font-bold mb-4">Customers</h1>
        
//         {/* Left Column: Stats Cards */}
//         <div className="flex gap-6 ">
//           <StatCard 
//             title="Total Customers" 
//             value={stats.total.toLocaleString()} 
//             percentage="14.4" 
//             isPositive={true} 
//           />
//           <StatCard 
//             title="New Customers" 
//             value={stats.new.toLocaleString()} 
//             percentage="20" 
//             isPositive={true} 
//           />
//           <StatCard 
//             title="Visitor" 
//             value={stats.visitors > 1000 ? `${(stats.visitors/1000).toFixed(0)}k` : stats.visitors} 
//             percentage="20" 
//             isPositive={true} 
//           />
//         </div>

//       {/* Bottom Layout: Table */}
//       <UserTable users={users} loading={loading} />

//     </div>
//   );
// };

// export default AllUsers;


// import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { 
//   ArrowUp, 
//   Pencil, // Edit Icon
//   X,
//   ShoppingBag,
//   IndianRupee,
//   Users
// } from 'lucide-react';
// import { toast } from 'react-hot-toast'; // Assuming you use react-hot-toast
// import SummaryApi from '../common/SummaryApi';
// import ROLE from '../common/role';
// import SelectDropdown from '../customStyles/SelectDropdown';

// // 1. Stats Card Component
// const StatCard = ({ title, value, subText, icon: Icon, colorClass }) => (
//   <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between h-[140px]">
//     <div className="flex justify-between items-start">
//       <h3 className="text-gray-500 font-medium text-sm">{title}</h3>
//       <div className={`p-2 rounded-lg ${colorClass} bg-opacity-10`}>
//         <Icon size={18} className={colorClass.replace('bg-', 'text-')} />
//       </div>
//     </div>
//     <div>
//       <div className="flex items-end gap-3 mb-1">
//         <h2 className="text-2xl font-bold text-gray-800">{value}</h2>
//       </div>
//       <p className="text-xs text-gray-400">{subText}</p>
//     </div>
//   </div>
// );

// // 2. Edit Role Modal Component
// const EditRoleModal = ({ isOpen, onClose, user, onUpdate }) => {
//   const [selectedRole, setSelectedRole] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (user) setSelectedRole(user.role);
//   }, [user]);

//   const handleUpdate = async () => {
//     if(!user) return;
//     setLoading(true);
//     try {
//       const response = await axios({
//         method: SummaryApi.updateUserRole.method,
//         url: SummaryApi.updateUserRole.url(user._id),
//         data: { role: selectedRole },
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//       });

//       if(response.data.success) {
//         toast.success(response.data.message);
//         onUpdate(user._id, selectedRole); // Update UI locally
//         onClose();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to update role");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
//       <div className="bg-white w-full max-w-sm rounded-xl shadow-2xl p-6 relative animate-fade-in">
//         <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
//           <X size={20} />
//         </button>
        
//         <h2 className="text-lg font-bold text-gray-800 mb-1">Update User Role</h2>
//         <p className="text-sm text-gray-500 mb-6">Change access level for <span className="font-semibold text-blue-600">{user?.email}</span></p>

//         <div className="space-y-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Select Role</label>
//             <select className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
//               value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
//                 {
//                     Object.values(ROLE).map(el => {
//                         return(
//                             <option value={el} key={el}>{el}</option>
//                         )
//                     })
//                 }
//             </select>
//           </div>

//           <button 
//             onClick={handleUpdate}
//             disabled={loading}
//             className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors disabled:opacity-70 flex justify-center items-center"
//           >
//             {loading ? <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full mr-2"></span> : "Save Changes"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // --- MAIN COMPONENT ---

// const AllUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // Modal State
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [currentUser, setCurrentUser] = useState(null);

//   // Stats State
//   const [stats, setStats] = useState({
//     totalCustomers: 0,
//     newCustomers: 0,
//     totalOrders: 0,
//     totalRevenue: 0
//   });

//   const fetchUsers = useCallback(async () => {
//     try {
//       const response = await axios({
//         method: SummaryApi.getAllUsers.method,
//         url: SummaryApi.getAllUsers.url,
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//       });

//       if (response.data.success) {
//         const fetchedUsers = response.data.data; // Note: based on your JSON, it's data.data
//         setUsers(fetchedUsers);
//         calculateStats(fetchedUsers);
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//       toast.error("Failed to load customers");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchUsers();
//   }, [fetchUsers]);

//   const calculateStats = (data) => {
//     const totalCustomers = data.length;
    
//     // New Customers (Last 7 Days)
//     const sevenDaysAgo = new Date();
//     sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
//     const newCustomers = data.filter(u => new Date(u.createdAt) > sevenDaysAgo).length;

//     // Total Orders (Sum of orderCount)
//     const totalOrders = data.reduce((acc, curr) => acc + (curr.orderCount || 0), 0);

//     // Total Revenue (Sum of totalSpend)
//     const totalRevenue = data.reduce((acc, curr) => acc + (curr.totalSpend || 0), 0);

//     setStats({ totalCustomers, newCustomers, totalOrders, totalRevenue });
//   };

//   const openEditModal = (user) => {
//     setCurrentUser(user);
//     setIsModalOpen(true);
//   };

//   const handleLocalUpdate = (userId, newRole) => {
//     setUsers(users.map(u => u._id === userId ? { ...u, role: newRole } : u));
//   };

//   // Helper to get initials if name is empty
//   const getName = (u) => {
//     if (u.firstName || u.lastName) return `${u.firstName} ${u.lastName}`;
//     return "Unknown User";
//   };

//   return (
//     <div className="min-h-screen p-4">
//       <h1 className="text-2xl font-bold mb-6 text-gray-800">Customer Management</h1>
        
//       {/* 4 DYNAMIC STATS CARDS */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
//         <StatCard 
//           title="Total Customers" 
//           value={stats.totalCustomers} 
//           subText="All registered users"
//           icon={Users}
//           colorClass="text-blue-600 bg-blue-600"
//         />
//         <StatCard 
//           title="New Customers" 
//           value={stats.newCustomers} 
//           subText="Joined in last 7 days"
//           icon={ArrowUp}
//           colorClass="text-green-600 bg-green-600"
//         />
//         <StatCard 
//           title="Total Orders" 
//           value={stats.totalOrders} 
//           subText="Lifetime orders count"
//           icon={ShoppingBag}
//           colorClass="text-purple-600 bg-purple-600"
//         />
//         <StatCard 
//           title="Total Revenue" 
//           value={`₹${stats.totalRevenue.toLocaleString()}`} 
//           subText="Lifetime spend"
//           icon={IndianRupee}
//           colorClass="text-orange-600 bg-orange-600"
//         />
//       </div>

//       {/* CUSTOMER TABLE */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[900px]">
//             <thead>
//               <tr className="bg-blue-600 text-left text-xs uppercase font-bold text-white tracking-wider">
//                 <th className="px-6 py-4">S.No</th>
//                 <th className="px-6 py-4">Customer Details</th>
//                 <th className="px-6 py-4">Phone</th>
//                 <th className="px-6 py-4">Orders</th>
//                 <th className="px-6 py-4">Total Spend</th>
//                 <th className="px-6 py-4">User Type</th>
//                 <th className="px-6 py-4 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-100">
//               {loading ? (
//                  <tr><td colSpan="7" className="text-center py-10 text-gray-500">Loading data...</td></tr>
//               ) : users.length === 0 ? (
//                  <tr><td colSpan="7" className="text-center py-10 text-gray-500">No customers found</td></tr>
//               ) : users.map((user, index) => (
//                 <tr key={user._id} className="hover:bg-gray-50 transition-colors text-sm text-gray-700">
//                   <td className="px-6 py-4 font-medium text-gray-400">
//                     {index+1}
//                   </td>
                  
//                   {/* NAME & EMAIL */}
//                   <td className="px-6 py-4">
//                     <div className="flex flex-col">
//                       <span className="font-semibold text-gray-900 capitalize">
//                         {getName(user)}
//                       </span>
//                       <span className="text-xs text-gray-500 mt-0.5 font-mono">
//                         {user.email}
//                       </span>
//                     </div>
//                   </td>

//                   <td className="px-6 py-4 font-mono text-gray-500">
//                     {user.phone || '-'}
//                   </td>

//                   <td className="px-6 py-4">
//                     <div className="whitespace-nowrap inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700">
//                       {user.orderCount} Orders
//                     </div>
//                   </td>

//                   <td className="px-6 py-4 font-semibold text-gray-900">
//                     ₹{user.totalSpend.toLocaleString()}
//                   </td>

//                   {/* USER TYPE (ROLE) */}
//                   <td className="px-6 py-4">
//                     <span className={`px-3 py-1 rounded-full text-xs font-semibold capitalize ${
//                       user.role === 'admin' 
//                         ? 'bg-purple-100 text-purple-700' 
//                         : 'bg-gray-100 text-gray-700'
//                     }`}>
//                       {user.role}
//                     </span>
//                   </td>

//                   {/* ACTION (EDIT) */}
//                   <td className="px-6 py-4">
//                     <div className="flex justify-center gap-3">
//                       <button 
//                         onClick={() => openEditModal(user)}
//                         className="p-2 rounded-full text-blue-500 hover:bg-blue-50 transition-colors"
//                         title="Edit Role"
//                       >
//                         <Pencil size={18} />
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MODAL */}
//       <EditRoleModal 
//         isOpen={isModalOpen} 
//         onClose={() => setIsModalOpen(false)} 
//         user={currentUser}
//         onUpdate={handleLocalUpdate}
//       />

//     </div>
//   );
// };

// export default AllUsers;

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { 
  ArrowUp, 
  Pencil, // Edit Icon
  X,
  ShoppingBag,
  IndianRupee,
  Users
} from 'lucide-react';
import { toast } from 'react-hot-toast'; 
import SummaryApi from '../common/SummaryApi';
import ROLE from '../common/role';
import SelectDropdown from '../customStyles/SelectDropdown'; 
import Pagination from '../helpers/Pagination';

// 1. Stats Card Component
const StatCard = ({ title, value, subText, icon: Icon, colorClass }) => (
  <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between h-[140px]">
    <div className="flex justify-between items-start">
      <h3 className="text-gray-500 font-medium text-sm">{title}</h3>
      <div className={`p-2 rounded-lg ${colorClass} bg-opacity-10`}>
        <Icon size={18} className={colorClass.replace('bg-', 'text-')} />
      </div>
    </div>
    <div>
      <div className="flex items-end gap-3 mb-1">
        <h2 className="text-2xl font-bold text-gray-800">{value}</h2>
      </div>
      <p className="text-xs text-gray-400">{subText}</p>
    </div>
  </div>
);

// 2. Edit Role Modal Component
const EditRoleModal = ({ isOpen, onClose, user, onUpdate }) => {
  const [selectedRole, setSelectedRole] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) setSelectedRole(user.role);
  }, [user]);

  // Transform ROLE object into options array for SelectDropdown
  const roleOptions = useMemo(() => {
    return Object.values(ROLE).map((role) => ({
      id: role,
      label: role.charAt(0).toUpperCase() + role.slice(1) // Capitalize (e.g., admin -> Admin)
    }));
  }, []);

  const handleUpdate = async () => {
    if(!user) return;
    setLoading(true);
    try {
      const response = await axios({
        method: SummaryApi.updateUserRole.method,
        url: SummaryApi.updateUserRole.url(user._id),
        data: { role: selectedRole },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      if(response.data.success) {
        toast.success(response.data.message);
        onUpdate(user._id, selectedRole); // Update UI locally
        onClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update role");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white w-full max-w-sm rounded-xl shadow-2xl p-6 relative animate-fade-in">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
          <X size={20} />
        </button>
        
        <h2 className="text-lg font-bold text-gray-800 mb-1">Update User Role</h2>
        <p className="text-sm text-gray-500 mb-6">Change access level for <span className="font-semibold text-blue-600">{user?.email}</span></p>

        <div className="space-y-6">
          
          {/* REPLACED NATIVE SELECT WITH CUSTOM DROPDOWN */}
          <SelectDropdown
            label="Select Role"
            options={roleOptions}
            value={selectedRole}
            onChange={(val) => setSelectedRole(val)} 
            placeholder="Choose a role"
            valueKey="id"
            labelKey="label"
            ChildClassName="w-full !p-3 !border-gray-300 !rounded-lg !text-gray-700"
            labelClassName="!text-gray-700 !font-medium"
          />

          <button 
            onClick={handleUpdate}
            disabled={loading}
            className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors disabled:opacity-70 flex justify-center items-center shadow-lg shadow-blue-200"
          >
            {loading ? <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full mr-2"></span> : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

// --- MAIN COMPONENT ---

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Change this to show more/less items

  // Modal State
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  // Stats State
  const [stats, setStats] = useState({
    totalCustomers: 0,
    newCustomers: 0,
    totalOrders: 0,
    totalRevenue: 0
  });

  const fetchUsers = useCallback(async () => {
    try {
      const response = await axios({
        method: SummaryApi.getAllUsers.method,
        url: SummaryApi.getAllUsers.url,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.data.success) {
        const fetchedUsers = response.data.data;
        setUsers(fetchedUsers);
        calculateStats(fetchedUsers);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to load customers");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const calculateStats = (data) => {
    const totalCustomers = data.length;
    
    // New Customers (Last 7 Days)
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    const newCustomers = data.filter(u => new Date(u.createdAt) > sevenDaysAgo).length;

    // Total Orders (Sum of orderCount)
    const totalOrders = data.reduce((acc, curr) => acc + (curr.orderCount || 0), 0);

    // Total Revenue (Sum of totalSpend)
    const totalRevenue = data.reduce((acc, curr) => acc + (curr.totalSpend || 0), 0);

    setStats({ totalCustomers, newCustomers, totalOrders, totalRevenue });
  };

  const openEditModal = (user) => {
    setCurrentUser(user);
    setIsModalOpen(true);
  };

  const handleLocalUpdate = (userId, newRole) => {
    setUsers(users.map(u => u._id === userId ? { ...u, role: newRole } : u));
  };

  // Helper to get initials if name is empty
  const getName = (u) => {
    if (u.firstName || u.lastName) return `${u.firstName} ${u.lastName}`;
    return "Unknown User";
  };

  // --- PAGINATION LOGIC ---
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = users.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">Customers</h1>
        
      {/* 4 DYNAMIC STATS CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatCard 
          title="Total Customers" 
          value={stats.totalCustomers} 
          subText="All registered users"
          icon={Users}
          colorClass="text-blue-600 bg-blue-600"
        />
        <StatCard 
          title="New Customers" 
          value={stats.newCustomers} 
          subText="Joined in last 7 days"
          icon={ArrowUp}
          colorClass="text-green-600 bg-green-600"
        />
        <StatCard 
          title="Total Orders" 
          value={stats.totalOrders} 
          subText="Lifetime orders count"
          icon={ShoppingBag}
          colorClass="text-purple-600 bg-purple-600"
        />
        <StatCard 
          title="Total Revenue" 
          value={`₹${stats.totalRevenue.toLocaleString()}`} 
          subText="Lifetime spend"
          icon={IndianRupee}
          colorClass="text-orange-600 bg-orange-600"
        />
      </div>

      {/* CUSTOMER TABLE */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">
            <thead>
              <tr className="bg-blue-600 text-left text-xs uppercase font-bold text-white tracking-wider">
                <th className="px-6 py-4">S.No</th>
                <th className="px-6 py-4">Customer Details</th>
                <th className="px-6 py-4">Phone</th>
                <th className="px-6 py-4">Orders</th>
                <th className="px-6 py-4">Total Spend</th>
                <th className="px-6 py-4">User Type</th>
                <th className="px-6 py-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? (
                 <tr><td colSpan="7" className="text-center py-10 text-gray-500">Loading data...</td></tr>
              ) : users.length === 0 ? (
                 <tr><td colSpan="7" className="text-center py-10 text-gray-500">No customers found</td></tr>
              ) : currentUsers.map((user, index) => (
                <tr key={user._id} className="hover:bg-gray-50 transition-colors text-sm text-gray-700">
                  <td className="px-6 py-4 font-medium text-gray-400">
                    {/* Calculate Global Index for S.No */}
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  
                  {/* NAME & EMAIL */}
                  <td className="px-6 py-4">
                    <div className="flex flex-col">
                      <span className="font-semibold text-gray-900 capitalize">
                        {getName(user)}
                      </span>
                      <span className="text-xs text-gray-500 mt-0.5 font-mono">
                        {user.email}
                      </span>
                    </div>
                  </td>

                  <td className="px-6 py-4 font-mono text-gray-500">
                    {user.phone || '-'}
                  </td>

                  <td className="px-6 py-4">
                    <div className="whitespace-nowrap inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700">
                      {user.orderCount} Orders
                    </div>
                  </td>

                  <td className="px-6 py-4 font-semibold text-gray-900">
                    ₹{user.totalSpend.toLocaleString()}
                  </td>

                  {/* USER TYPE (ROLE) */}
                  <td className="px-6 py-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold capitalize ${
                      user.role === 'admin' 
                        ? 'bg-purple-100 text-purple-700' 
                        : 'bg-gray-100 text-gray-700'
                    }`}>
                      {user.role}
                    </span>
                  </td>

                  {/* ACTION (EDIT) */}
                  <td className="px-6 py-4">
                    <div className="flex justify-center gap-3">
                      <button 
                        onClick={() => openEditModal(user)}
                        className="p-2 rounded-full text-blue-500 hover:bg-blue-50 transition-colors"
                        title="Edit Role"
                      >
                        <Pencil size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* PAGINATION COMPONENT */}
        {!loading && users.length > 0 && (
          <div className="p-4 border-t border-gray-100">
            <Pagination 
              totalItems={users.length}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </div>
        )}
      </div>

      {/* MODAL */}
      <EditRoleModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        user={currentUser}
        onUpdate={handleLocalUpdate}
      />

    </div>
  );
};

export default AllUsers;